import { createContext, useContext } from "react";
import type { AiResultHandoff } from "./aiResultHandoff";
import type { DocumentScope } from "./documentScope";

interface AssistantPanelContextValue {
  panelOpen: boolean;
  openPanel: () => void;
  reopenPanel?: () => void;
  openOnPage?: () => void;
  pageRequest?: number;
  closePanel: () => void;
  handoff?: AiResultHandoff | null;
  openWithResult?: (handoff: AiResultHandoff) => void;
  takeHandoff?: () => AiResultHandoff | null;
  clearHandoff?: () => void;
  documentScope?: DocumentScope | null;
  openWithDocument?: (scope: DocumentScope) => void;
  introducing?: boolean;
  question?: AskedQuestion | null;
  openWithQuestion?: (question: string, startButtonLabel?: string) => void;
}

export type AskedQuestion = { id: number; text: string; startButtonLabel?: string };

export const AssistantPanelContext = createContext<AssistantPanelContextValue | undefined>(undefined);

export const useAssistantPanel = (): AssistantPanelContextValue => {
  const context = useContext(AssistantPanelContext);
  if (context === undefined) {
    throw new Error("useAssistantPanel must be used within an AssistantProvider");
  }
  return context;
};
